/**
 * Conflict[] builder — centralized so the `Conflict` tagged union (`05-` §A.7)
 * stays consistent and no caller invents new kinds.
 *
 * Phase C scope: tiny stub. Filled in during Day 3 + Day 5.
 *
 * Note on Part I §6 (the v1 root cause): every comparator added here must
 * gate on `!= undefined` for the constraint date before comparing against
 * a candidate timestamp. v1's `plan.start_date > plan.latestStart` against
 * undefined coerced silently to `> 0` and produced phantom conflicts. Tests
 * for `getConstraintLimits` exercise that path against the planner.
 */

import type { Conflict, ConstraintType, LinkID, TaskID } from "../types";

export type ConflictAccumulator = Conflict[];

export function newAccumulator(): ConflictAccumulator {
  return [];
}

export function pushConstraintViolation(
  acc: ConflictAccumulator,
  taskId: TaskID,
  constraintType: ConstraintType,
  violation: "earliest-start" | "latest-start" | "earliest-end" | "latest-end",
  required: Date,
  actual: Date
): void {
  acc.push({ kind: "constraint-violation", taskId, constraintType, violation, required, actual });
}

export function pushCalendarNonWorking(
  acc: ConflictAccumulator,
  taskId: TaskID,
  proposedDate: Date,
  snappedDate: Date
): void {
  acc.push({ kind: "calendar-non-working", taskId, proposedDate, snappedDate });
}

export function pushCycle(
  acc: ConflictAccumulator,
  taskIds: readonly TaskID[],
  linkIds: readonly LinkID[]
): void {
  acc.push({ kind: "cycle", taskIds, linkIds });
}

export function pushUnscheduledDependency(
  acc: ConflictAccumulator,
  taskId: TaskID,
  blockedBy: TaskID
): void {
  acc.push({ kind: "unscheduled-dependency", taskId, blockedBy });
}
